import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "status"];

  save() {
    const input = this.inputTarget;
    const url = this.element.getAttribute("action");
    const body = new FormData(this.element);

    input.disabled = true;
    this.setStatus("saving");

    fetch(url, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "X-Requested-With": "XMLHttpRequest",
      },
      credentials: "same-origin",
      body,
    })
      .then((response) => {
        if (!response.ok) throw new Error("save failed");
        this.setStatus("saved");
      })
      .catch(() => {
        input.checked = !input.checked;
        this.setStatus("error");
      })
      .finally(() => {
        input.disabled = false;
      });
  }

  setStatus(state) {
    if (!this.hasStatusTarget) return;

    clearTimeout(this.savedTimer);
    this.statusTarget.dataset.state = state;

    if (state === "error") {
      this.showErrorTooltip();
    } else {
      this.hideErrorTooltip();
    }

    if (state === "saved") {
      this.savedTimer = setTimeout(() => {
        if (this.statusTarget.dataset.state === "saved") {
          this.statusTarget.dataset.state = "idle";
        }
      }, 1500);
    }
  }

  showErrorTooltip() {
    const $status = $(this.statusTarget);
    $status
      .attr({
        "data-toggle": "tooltip",
        title:
          "Please try again. If this problem persists please contact your provider.",
      })
      .tooltip("dispose")
      .tooltip();
  }

  hideErrorTooltip() {
    $(this.statusTarget).tooltip("dispose").removeAttr("data-toggle title");
  }
}
